import { put } from 'redux-saga/effects';

import { InsighttNotification } from '../../helpers/insightt-notification';
import ShiftsActions from '../actions/shifts.actions';

export function* getAllShiftsRequest(api) {
  const response = yield api.getAllShifts();
  if (response && response.ok) {
    yield put(ShiftsActions.getAllShiftsSuccess(response.data));
  } else {
    yield put(ShiftsActions.getAllShiftsFailure());
  }
}

export function* getUserShiftsRequest(api, action) {
  const { day } = action;
  const response = yield api.getUserShifts(day);
  if (response && response.ok) {
    yield put(ShiftsActions.getUserShiftsSuccess(response.data));
  } else {
    yield put(ShiftsActions.getUserShiftsFailure());
  }
}

export function* getShiftRequest(api, action) {
  const { shiftId } = action;
  const response = yield api.getShiftDetails(shiftId);
  if (response && response.ok) {
    yield put(ShiftsActions.getShiftSuccess(response.data));
  } else {
    yield put(ShiftsActions.getShiftFailure());
  }
}

export function* createShiftRequest(api, action) {
  const { payload } = action;
  const response = yield api.createShift(payload);
  if (response && response.ok) {
    yield put(ShiftsActions.createShiftSuccess(response.data));
    InsighttNotification('success', 'New Shift was created successfully.', response);
  } else {
    InsighttNotification('error', 'Unable to create New Shift', response);
    yield put(ShiftsActions.createShiftFailure());
  }
}

export function* updateShiftRequest(api, action) {
  const { shiftId, payload } = action;
  const response = yield api.updateShift(shiftId, payload);
  if (response && response.ok) {
    yield put(ShiftsActions.updateShiftSuccess(response.data));
    InsighttNotification('success', 'Shift was updated successfully.', response);
  } else {
    InsighttNotification('error', 'Unable to update the Shift', response);
    yield put(ShiftsActions.updateShiftFailure(shiftId));
  }
}

export function* deleteShiftRequest(api, action) {
  const { shiftId } = action;
  const response = yield api.deleteShift(shiftId);
  if (response && response.ok) {
    yield put(ShiftsActions.deleteShiftSuccess(shiftId));
    InsighttNotification('success', 'Shift was deleted successfully.', response);
  } else {
    let errorMessage = response?.data?.message || 'Unable to delete shift';
    errorMessage = errorMessage.replace('APIError: ', '');
    InsighttNotification('error', errorMessage);
    yield put(ShiftsActions.deleteShiftFailure(shiftId));
  }
}
